import React from 'react';

// ─────────────────────────────────────────────────────────────
//  CategoryIcon — hand-drawn SVG icons replacing emoji
//  Consistent rounded, friendly style across the whole site.
//  <CategoryIcon name="games" size={40} />
// ─────────────────────────────────────────────────────────────

const ICONS = {
  games: (
    <g>
      <rect x="6" y="14" width="36" height="22" rx="11" fill="#7C6FE0" />
      <rect x="6" y="14" width="36" height="11" rx="8" fill="#8F83EA" />
      <rect x="13" y="21" width="10" height="4" rx="2" fill="#FFF" />
      <rect x="16" y="18" width="4" height="10" rx="2" fill="#FFF" />
      <circle cx="32" cy="21" r="2.6" fill="#FFD34D" />
      <circle cx="37" cy="26" r="2.6" fill="#FF7D6B" />
    </g>
  ),
  coloring: (
    <g>
      <path d="M24 6 C 12 6 6 15 6 23 c 0 9 7 15 14 15 3 0 4-2 4-4 0-2-2-3-2-5 0-2 2-3 5-3 h 4 c 6 0 11-4 11-10 C 42 10 34 6 24 6 Z" fill="#F4A83C" />
      <circle cx="15" cy="18" r="3.2" fill="#EF5D5D" />
      <circle cx="24" cy="13" r="3.2" fill="#4FA3E8" />
      <circle cx="33" cy="17" r="3.2" fill="#6BBF67" />
      <circle cx="13" cy="27" r="3.2" fill="#9B6FD9" />
    </g>
  ),
  stories: (
    <g>
      <path d="M24 12 C 20 8 13 7 7 9 v 26 c 6 -2 13 -1 17 3 4 -4 11 -5 17 -3 V 9 c -6 -2 -13 -1 -17 3 Z" fill="#5BA8E8" />
      <path d="M24 12 v 26" stroke="#3D7DBE" strokeWidth="2.4" />
      <path d="M11 16 q 5 -1 9 1 M11 22 q 5 -1 9 1 M11 28 q 5 -1 9 1" stroke="#EAF5FF" strokeWidth="2.2" strokeLinecap="round" fill="none" />
      <path d="M28 17 q 5 -2 9 -1 M28 23 q 5 -2 9 -1" stroke="#EAF5FF" strokeWidth="2.2" strokeLinecap="round" fill="none" />
    </g>
  ),
  books: (
    <g>
      <rect x="8" y="26" width="30" height="8" rx="3" fill="#E86B5A" transform="rotate(-4 8 26)" />
      <rect x="10" y="18" width="28" height="8" rx="3" fill="#5BA8E8" transform="rotate(2 10 18)" />
      <rect x="9" y="10" width="26" height="8" rx="3" fill="#F4B33C" transform="rotate(-2 9 10)" />
      <circle cx="36" cy="12" r="5" fill="#FFE08A" />
      <path d="M36 9 l 1 2 2 .3 -1.5 1.4 .4 2 -1.9 -1 -1.9 1 .4 -2 -1.5 -1.4 2 -.3 Z" fill="#E8963C" />
    </g>
  ),
  math: (
    <g>
      <rect x="7" y="7" width="16" height="16" rx="5" fill="#6BBF67" />
      <rect x="25" y="7" width="16" height="16" rx="5" fill="#F4B33C" />
      <rect x="7" y="25" width="16" height="16" rx="5" fill="#5BA8E8" />
      <rect x="25" y="25" width="16" height="16" rx="5" fill="#E86B5A" />
      <text x="15" y="20" textAnchor="middle" fontSize="12" fontWeight="bold" fill="#FFF" fontFamily="sans-serif">1</text>
      <text x="33" y="20" textAnchor="middle" fontSize="12" fontWeight="bold" fill="#FFF" fontFamily="sans-serif">2</text>
      <text x="15" y="38" textAnchor="middle" fontSize="12" fontWeight="bold" fill="#FFF" fontFamily="sans-serif">3</text>
      <text x="33" y="38" textAnchor="middle" fontSize="12" fontWeight="bold" fill="#FFF" fontFamily="sans-serif">+</text>
    </g>
  ),
  explore: (
    <g>
      <circle cx="24" cy="24" r="17" fill="#5BA8E8" />
      <path d="M14 16 q 5 -3 8 0 q 2 3 -1 5 q -4 1 -5 5 q -1 3 -4 2 q -3 -5 2 -12 Z" fill="#6BBF67" />
      <path d="M30 26 q 5 -1 6 3 q 0 4 -4 6 q -4 1 -5 -2 q -1 -4 3 -7 Z" fill="#6BBF67" />
      <ellipse cx="24" cy="24" rx="17" ry="17" fill="none" stroke="#3D7DBE" strokeWidth="2" />
    </g>
  ),
  songs: (
    <g>
      <path d="M18 34 V 12 l 20 -4 v 20" stroke="#7C6FE0" strokeWidth="3.4" fill="none" strokeLinecap="round" />
      <ellipse cx="14" cy="34" rx="5.4" ry="4.4" fill="#7C6FE0" />
      <ellipse cx="34" cy="28" rx="5.4" ry="4.4" fill="#9B6FD9" />
      <path d="M8 12 q 2 -3 4 0 M6 18 q 2 -3 4 0" stroke="#F4B33C" strokeWidth="2" fill="none" strokeLinecap="round" />
    </g>
  ),
  quizzes: (
    <g>
      <path d="M14 8 h 12 a 6 6 0 0 1 6 6 v 4 h 2 a 4 4 0 0 1 0 8 h -2 v 8 a 6 6 0 0 1 -6 6 h -4 v -3 a 4 4 0 0 0 -8 0 v 3 h -4 a 6 6 0 0 1 -6 -6 v -6 h 3 a 4 4 0 0 0 0 -8 h -3 v -6 a 6 6 0 0 1 6 -6 Z" fill="#4FBFA8" transform="translate(4 0)" />
      <circle cx="26" cy="20" r="2.2" fill="#FFF" />
      <path d="M22 27 q 4 3 8 0" stroke="#FFF" strokeWidth="2.2" fill="none" strokeLinecap="round" />
    </g>
  ),
  home: (
    <g>
      <path d="M24 8 L 42 23 h -5 v 15 a 2 2 0 0 1 -2 2 h -8 v -10 h -6 v 10 h -8 a 2 2 0 0 1 -2 -2 V 23 h -5 Z" fill="#E8875A" />
      <rect x="21" y="28" width="6" height="12" rx="1.4" fill="#8A5230" />
      <circle cx="24" cy="21" r="3.4" fill="#FFE9B8" />
    </g>
  ),
  badges: (
    <g>
      <circle cx="24" cy="20" r="12" fill="#F4B33C" />
      <circle cx="24" cy="20" r="8" fill="#FFD97A" />
      <path d="M24 14 l 1.8 3.6 4 .6 -2.9 2.8 .7 4 -3.6 -1.9 -3.6 1.9 .7 -4 -2.9 -2.8 4 -.6 Z" fill="#E8875A" />
      <path d="M17 30 l -4 10 6 -3 3 5 3 -9 M31 30 l 4 10 -6 -3 -3 5" fill="#5BA8E8" />
    </g>
  ),
  premium: (
    <g>
      <path d="M24 6 l 4.6 9.3 10.3 1.5 -7.5 7.3 1.8 10.2 L 24 29.5 l -9.2 4.8 1.8 -10.2 -7.5 -7.3 10.3 -1.5 Z" fill="#F4B33C" />
      <path d="M24 12 l 2.8 5.6 6.2 .9 -4.5 4.4 1 6.1 -5.5 -2.9 -5.5 2.9 1 -6.1 -4.5 -4.4 6.2 -.9 Z" fill="#FFE08A" />
    </g>
  ),
  parents: (
    <g>
      <circle cx="17" cy="15" r="6" fill="#5BA8E8" />
      <circle cx="31" cy="15" r="6" fill="#E86B5A" />
      <path d="M7 40 v -6 a 10 10 0 0 1 20 0 v 6 Z" fill="#5BA8E8" />
      <path d="M21 40 v -6 a 10 10 0 0 1 20 0 v 6 Z" fill="#E86B5A" opacity="0.92" />
    </g>
  ),
};

export default function CategoryIcon({ name, size = 40, className = '', label }) {
  const icon = ICONS[name];
  if (!icon) return <span style={{ fontSize: size * 0.8 }}>{label || '⭐'}</span>;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      className={className}
      role="img"
      aria-label={label || name}
    >
      {icon}
    </svg>
  );
}
